<template>
    <confirmation-modal title-key="companyUserPermission.create" :confirm="confirm" :valid="valid">
      <wo-region v-if="permissions">
        <wo-label v-t="'companyUserPermission.user'" />
        <po-selector v-model="pendingItem.user" :search="searchUser" v-focus="true" :label-factory="createUserLabel" />
        <wo-label v-t="'companyUserPermission.permission'" />
        <po-selector v-model="pendingItem.permission" :options="permissions"/>
      </wo-region>
    </confirmation-modal>
</template>

<script>

import { mapState } from 'vuex'

import { Company, CompanyUserPermission, CompanyPermissionEnum } from '@/model/company'

import { companyUserPermissionRepository } from '@/repository/company'
import { enumerationRepository } from '@/repository/enumeration'
import { userRepository } from '@/repository/identity'

import ConfirmationModal from '@/components/modal/ConfirmationModal'

export default {
  components: { ConfirmationModal },
  props: {
    company: Company
  },
  data () {
    return {
      pendingItem: undefined
    }
  },
  created () {
    this.pendingItem = new CompanyUserPermission()
    this.$store.dispatch(enumerationRepository.find, CompanyPermissionEnum)
  },
  computed: mapState({
    permissions: state => state.enumeration[CompanyPermissionEnum.id],
    valid () {
      return !!this.pendingItem.user && !!this.pendingItem.permission
    }
  }),
  methods: {
    confirm () {
      return this.$store.dispatch(companyUserPermissionRepository.create, { companyId: this.company.id, entity: this.pendingItem })
    },
    searchUser (searchText) {
      const filter = { search_text: searchText }
      return this.$store.dispatch(userRepository.findAll, { filter })
    },
    createUserLabel (option) {
      return option.fullDisplayName
    }
  }
}
</script>
